
export class LeverantorsstatusSearchFilter {
// eslint-disable-next-line sonarjs/public-static-readonly
    static Virkesleverantor = "Virkesleverantor";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Anbudsleverantor = "Anbudsleverantor";
}
